import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule , HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { ToastrModule } from 'ngx-toastr';
import { MatDialogModule} from '@angular/material';

import { 
  MatToolbarModule,MatIconModule,MatSidenavModule,MatListModule,MatButtonModule,
  MatBadgeModule,MatCardModule,MatSelectModule,MatRadioModule,
  MatInputModule,MatChipsModule,MatFormFieldModule,MatDatepickerModule,
  MatNativeDateModule,MatMenuModule,MatCheckboxModule, MAT_DATE_LOCALE,
 } from '@angular/material';
import { UserService } from './services/user.service';
import { SelectdropdownService } from './services/selectdropdown.service';
import { MainpageService } from './services/mainpage.service';
import { BoardService } from './services/board.service';
import { AuthService } from './services/auth.service';
import { ProfileService } from './services/profile.service';
import { AddrequestService } from './services/addrequest.service';
import { ChangepasswordService } from './services/changepassword.service';
import { ForgertpasswordService } from './services/forgertpassword.service';
import { Interceptor } from './services/interceptor';
import { AuthGuard } from './guards/auth.guard';
import { HomeauthGuard } from './guards/homeauth.guard';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { FontAwesomeModule ,FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { HomeComponent } from './components/home/home.component';
import { BoardComponent } from './components/board/board.component';
import { MainComponent } from './components/main/main.component';
import { AddrequestComponent } from './components/addrequest/addrequest.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ProfileComponent } from './components/profile/profile.component';
import { InsideloaderComponent } from './components/insideloader/insideloader.component';
import { DeletemodalComponent } from './components/deletemodal/deletemodal.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { RequestmodalComponent } from './components/requestmodal/requestmodal.component';
import { ForgetpasswordmodalComponent } from './components/forgetpasswordmodal/forgetpasswordmodal.component';
import { ResetpasswordComponent } from './components/resetpassword/resetpassword.component';
import { IncomemodalComponent } from './components/incomemodal/incomemodal.component';
import { DutymodalComponent } from './components/dutymodal/dutymodal.component';
import { FamilymembersmodalComponent } from './components/familymembersmodal/familymembersmodal.component';
import {MatTabsModule} from '@angular/material/tabs';
import { RequestmodalValidationComponent } from './components/requestmodal-validation/requestmodal-validation.component';
import { AttachmentsmodalComponent } from './components/attachmentsmodal/attachmentsmodal.component';
import { SignInDialogComponentComponent } from './components/sign-in-dialog-component/sign-in-dialog-component.component';
import { Dialog1Component } from './components/dialog1/dialog1.component';
import { Dialog2Component } from './components/dialog2/dialog2.component';
import { Dialog3Component } from './components/dialog3/dialog3.component';
import { SafePipe } from './safe.pipe';
import { DialogService } from './services/dialog.service';



export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BoardComponent,
    MainComponent,
    AddrequestComponent,
    LoadingComponent,
    ProfileComponent,
    InsideloaderComponent,
    DeletemodalComponent,
    ChangepasswordComponent,
    RequestmodalComponent,
    ForgetpasswordmodalComponent,
    ResetpasswordComponent,
    IncomemodalComponent,
    DutymodalComponent,
    FamilymembersmodalComponent,
    RequestmodalValidationComponent,
    AttachmentsmodalComponent,
    SignInDialogComponentComponent,
    Dialog1Component,
    Dialog2Component,
    Dialog3Component,
    SafePipe,
  ],
  
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatButtonModule,
    FontAwesomeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    CarouselModule,
    MatTabsModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(options),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'ar',
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
    }),
    MatIconModule,
    
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    // Guards
    AuthGuard,HomeauthGuard,
    // Services
    MatDatepickerModule,SelectdropdownService,UserService,MainpageService,BoardService,ChangepasswordService,ForgertpasswordService,DialogService,
    AuthService,{ provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },ProfileService,AddrequestService,{provide: MAT_DATE_LOCALE, useValue: 'en-GB'}
  ],
  bootstrap: [AppComponent],
  entryComponents:[
    DeletemodalComponent,RequestmodalComponent,ForgetpasswordmodalComponent,
    IncomemodalComponent,DutymodalComponent,FamilymembersmodalComponent,RequestmodalValidationComponent,
    IncomemodalComponent,DutymodalComponent,FamilymembersmodalComponent,AttachmentsmodalComponent,SignInDialogComponentComponent,Dialog1Component,Dialog2Component,Dialog3Component
  ]
})
export class AppModule { }
